import { feature, Feature, Polygon } from '@turf/helpers';
import * as d3 from 'd3';

export class MathAux {
    
  /**
   * Calculates distance between two points.
   * Chamado por: getStationWeights
   * 
   * @param lat1 latitude do ponto 1
   * @param long1 longitude do ponto 1
   * @param lat2 latitude do ponto 2
   * @param long2 longitude do ponto 2
   * @return distância euclidiana entre dois pontos
   */
  static distance(lat1: number, long1: number, lat2: number, long2: number): number {
    return Math.sqrt(Math.pow((lat2 - lat1),2) + Math.pow((long2 - long1),2));
  }

  /**
   * Arredonda um número para uma dada quantidade de casas decimais.
   * Chamado por: centroid
   * 
   * @param value valor a ser arredondado
   * @param decimalPlaces número de casas decimais
   * @return número arredondado
   */
  static round(value: number, decimalPlaces: number): number {
    let power = Math.pow(10, decimalPlaces);
    return Math.round(value * power) / power;
  }

  /**
   * Calcula o centróide (ponto médio) de uma coleção de pontos [longitude, latitude].
   * Chama: round
   * Chamado por: 
   * 
   * @param points array de pontos [lon, lat].
   * @return centróide com as coordenadas arredondadas em 3 casas decimais.
   */
  static centroid(points: number[][]): number[] {

    const len = points.length;
    let sumLat = 0, sumLon = 0;

    points.forEach(p => {
      sumLat += p[1];
      sumLon += p[0];
    });

    let avgLat = sumLat / len;
    let avgLon = sumLon / len;
    
    return [this.round(avgLat, 3), this.round(avgLon, 3)];
  }

  /**
   * Cria um array dos percentis 10% até 90% de vias ordenadas pelos valores de chuva.
   * Chamado por: processResponse
   * 
   * @param segments_data array de vias ordenado pelos valores de chuva previstos
   * @return array das vias do 10-percentil até o 90-percentil
   */
  static createMiddleData(data: any[], percentil: number[]): any[]{
    let middle_data: number[] = []; //Stores rain_value data that is situated between 10% percentile and 90% percentile
    let i = 0;
    let increment = 1/data.length;
    
    if (data.length <= 2) return data;
    
    data.forEach(function(elem: any){
      if(i >= (percentil[0]/100) && i <= (percentil[1]/100)){
        middle_data.push(elem);
      }
      i += increment;
    });

    return middle_data;
  }

  /**
  * Seleciona os elementos que estão nos percentis especificados.
  * Chamado por: updateHeatMap, generateDiscreteHeatMapRain
  * 
  * @param data elementos previamente ordenados
  * @param percentil percentis que serão selecionados. Ex.: 10 para 10-percentil e 50 para a mediana
  * @returns array com os elementos do array data que estão nas posições indicadas pelo array percentil.
  */
  static createDiscreteMiddleData(data: number[], percentil: number[]): number[] {
    let middleData = [];
    const numSegments = data.length;
    for (let percent of percentil) {
      // evitando o caso do valor -1 atribuído aos pontos da borda da interpolação
      if (percent >= 0) {
        let percentVal = d3.quantileSorted(data, percent / 100);
        middleData.push(percentVal);
      }
    }
    return middleData;
  }

  /**
   * Deep copy function for TypeScript.
   * @param T Generic type of target/copied value.
   * @param target Target value to be copied.
   * @see Source project, ts-deeply https://github.com/ykdr2017/ts-deepcopy
   * @see Code pen https://codepen.io/erikvullings/pen/ejyBYg
   */
   public static deepCopy<T>(target: T): T {
    if (target === null) {
      return target
    }
    if (target instanceof Date) {
      return new Date(target.getTime()) as any
    }
    // First part is for array and second part is for Realm.Collection
    // if (target instanceof Array || typeof (target as any).type === 'string') {
    if (typeof target === 'object') {
      if (typeof (target as { [key: string]: any })[(Symbol as any).iterator] === 'function') {
        const cp = [] as any[]
        if ((target as any as any[]).length > 0) {
          for (const arrayMember of target as any as any[]) {
            cp.push(MathAux.deepCopy(arrayMember))
          }
        }
        return cp as any as T
      } else {
        const targetKeys = Object.keys(target)
        const cp = {} as { [key: string]: any };
        if (targetKeys.length > 0) {
          for (const key of targetKeys) {
            cp[key] = MathAux.deepCopy((target as { [key: string]: any })[key])
          }
        }
        return cp as T
      }
    }
    // Means that object is atomic
    return target
  }



  public static getExtremeCoordsOfPolygon(type:string,data:Feature<Polygon>):number[]{
    let max = Number.MIN_SAFE_INTEGER
    let min = Number.MAX_SAFE_INTEGER
    let axis = (type = 'lat') ? 1 : 0
    data.geometry.coordinates[0].forEach( (val)=>{
      if(max < val[axis]){
        max = val[axis]
      }
      if(min > val[axis]){
        min = val[axis]
      }
    })

    return [min,max]
  }

  public static LPAD(numero: string | number){
    if (+(numero) <= 9) 
      return "0" + numero;
    else
      return numero; 
}
} 